import { defineComponent as _defineComponent } from 'vue'
import {useProposalsStore} from "@/store/proposals.store";
import {Proposal, ProposalStatus} from "@/models/store/proposal";
import { VoteOption } from "@/models/store/proposal";
import { computed, onMounted } from "vue";
import CoinAmount from "../commons/CoinAmount.vue";
import PercentsView from "@/components/commons/PercentsView";
import DateCommon from "@/components/commons/DateCommon.vue";
import ProposalType from "./ProposalType.vue";
import {useConfigurationStore} from "@/store/configuration.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProposalDetails',
  props: {
    proposal: { type: Object, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props;

onMounted(() => {
  console.log(props.proposal);
});

const proposalsStore = useProposalsStore();
const url = useConfigurationStore().config.explorerUrl + "/proposals/" + props.proposal?.proposalId;
// const formattedDate = (value: Date) => {
//   return moment(value).format('DD MMMM YYYY HH:mm:ss');
// };

const voted = computed(() => {
  return useProposalsStore().userVote;
});
const icons  = new Map<string, string>([
  [ProposalStatus.PASSED, "CheckSquare"],
  [ProposalStatus.REJECTED, "XCircle"],
  [ProposalStatus.DEPOSIT_PERIOD, ""],
  [ProposalStatus.FAILED, ""],
  [ProposalStatus.VOTING_PERIOD, ""],
  [ProposalStatus.UNSPECIFIED, ""]
]);

const __returned__ = { props, proposalsStore, url, voted, icons, get VoteOption() { return VoteOption }, CoinAmount, get PercentsView() { return PercentsView }, DateCommon, ProposalType }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})